<template>
  <div style="height:100%;width:100%;" id="app">
    <router-view ref="routerView" class="router-content"></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import GLOBAL from '../../../components/jiri/Global'
import browers from '../../../../plugins/browser.js'
import callapp from 'callapp'
export default {
  beforeMount() {},
  mounted() {
    var that = this
    callapp('uiCloseBtn', { hide: 'true' })
    // 获取token和城市ID
    that.getTokenAndCity()
    // 判断是否为app内
    that.isApp = browers().isApp
    // 如果url中指定了跳转画面,跳转至相应页面
    if (GLOBAL.getUrlParam('pageName')) {
      // 如果是分享画面
      if (decodeURI(GLOBAL.getUrlParam('pageName')) == 'Share') {
        location.replace(
          'share.html?budgetId=' + decodeURI(GLOBAL.getUrlParam('budgetId'))
        )
        // 其他画面
      } else {
        location.replace(decodeURI(GLOBAL.getUrlParam('pageName')) + '.html')
      }
      // 如果url中未指定跳转画面,跳转至首页
    } else {
      //如果是开始计算登录成功跳转过来的携带预算总额参数
      if(GLOBAL.getUrlParam('budgetTotalAmount')){
        if(!that.isApp){
          location.replace('calculate.html?budgetTotalAmount='+GLOBAL.getUrlParam('budgetTotalAmount'))
          return
        }
         // 后台API请求参数
        let requestData = {
          budgetTotalAmount: GLOBAL.getUrlParam('budgetTotalAmount')
        }
        // 计算预算相关明细信息
        axios
          .post(GLOBAL.getUrlDomainForBudget() + 'calculateBudget', requestData, {
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
              'city-id': that.cityId,
              Authorization: that.token
            }
          })
          .then(function(response) {
            var code = response.data.code
            // 成功
            if (code === 0) {
              // 跳转至结婚预算明细页面
              location.assign('detail.html')
            }
          })
          .catch(function() {})
      }
      // 根据用户信息获取已查询预算数量，并根据已查询数量跳转至相应画面(已查询：跳转至结婚预算画面 未查询：跳转至计算预算画面)
      if(!that.isApp){
        location.replace('calculate.html')
        return
      }
      that.countBudgetByUser()
    }
  },
  data() {
    return {
      cityId: 0,
      token: '',
      isApp: false
    }
  },

  methods: {
    /**
     * 获取token和城市ID
     */
    getTokenAndCity() {
      var that = this
      // 城市ID
      that.cityId = GLOBAL.getCookie('city-id')
      // token
      that.token = GLOBAL.getCookie('Authorization')
    },
    /**
     * 根据用户信息获取已查询预算数量，并根据已查询数量跳转至相应画面(已查询：跳转至结婚预算画面 未查询：跳转至计算预算画面)
     */
    countBudgetByUser() {
      var that = this
      // 后台API请求参数
      let requestData = {}
      // 获取日期信息
      axios
        .post(
          GLOBAL.getUrlDomainForBudget() + 'countBudgetByUser',
          requestData,
          {
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
              'city-id': that.cityId,
              Authorization: that.token
            }
          }
        )
        .then(function(response) {
          var code = response.data.code
          // 成功
          if (code === 0) {
            
            // 已经计算过预算，跳过计算预算画面，直接进入结婚预算画面
            if (response.data.data > 0) {
              location.replace('detail.html')
              // 未计算过预算，进入计算预算画面
            } else {
              location.replace('calculate.html')
            }
          }
        })
        .catch(function() {})
    }
  }
}
</script>

<style>
.router-content {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
